var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialHandover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.666-80q-27.5 0-47.083-19.583T120-146.666V-619q-17.333-7.667-28.667-23.759Q80-658.851 80-680v-133.334q0-27.5 19.583-47.083T146.666-880h666.668q27.5 0 47.083 19.583T880-813.334V-680q0 21.149-11.333 37.241Q857.333-626.667 840-619v472.334q0 27.5-19.583 47.083T773.334-80H186.666Zm-40-600h666.668v-133.334H146.666V-680ZM360-413.334h240V-480H360v66.666Z",
    fill: "#034F81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialHandover);
export default __webpack_public_path__ + "static/media/Material Handover.9354f81a5b910a30c7f9bd1e6b6b6dea.svg";
export { ForwardRef as ReactComponent };